(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["treatments-campaign-video"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('treatments-campaign')){
 customElements.define('treatments-campaign',class extends HTMLElement{
  connectedCallback(){
   this.video=this.querySelector('video');this.button=this.querySelector('button');if(!this.video||!this.button)return;
   this.controller=new AbortController();const options={signal:this.controller.signal};
   this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.userPaused=this.motion.matches || navigator.connection?.saveData === true;
   this.video.muted=true;this.video.controls=false;this.button.hidden=false;
   this.update=()=>{const text=this.video.paused?this.dataset.play:this.dataset.pause;this.button.textContent=text;this.button.setAttribute('aria-label',text);};
   this.video.addEventListener('play',this.update,options);this.video.addEventListener('pause',this.update,options);
   this.button.addEventListener('click',()=>{if(this.video.paused){this.userPaused=false;this.video.play().catch(()=>this.update());}else{this.userPaused=true;this.video.pause();}},options);
   this.motion.addEventListener('change',()=>{if(this.motion.matches){this.userPaused=true;this.video.pause();}},options);
   this.observer=new IntersectionObserver(entries=>{this.onScreen=entries[0].isIntersecting;this.syncPlayback();},{threshold:.15});this.observer.observe(this);
   document.addEventListener('visibilitychange',()=>this.syncPlayback(),options);this.update();
  }
  syncPlayback(){if(this.onScreen&&!document.hidden&&!this.userPaused){this.video.play().catch(()=>this.update());}else{this.video.pause();}}
  disconnectedCallback(){this.controller?.abort();this.observer?.disconnect();this.video?.pause();}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["treatments-collection-film"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('treatments-collection-film')) {
 customElements.define('treatments-collection-film', class extends HTMLElement {
  connectedCallback() {
   this.video = this.querySelector('video');
   this.button = this.querySelector('button');
   if (!this.video || !this.button) return;
   this.controller = new AbortController();
   const options = {signal: this.controller.signal};
   this.motion = matchMedia('(prefers-reduced-motion: reduce)');
   this.userPaused=this.motion.matches || navigator.connection?.saveData === true;
   this.video.muted = true;
   this.video.controls = false;
   this.button.hidden = false;
   this.update = () => { this.button.textContent = this.video.paused ? this.dataset.play : this.dataset.pause; };
   this.video.addEventListener('play', this.update, options);
   this.video.addEventListener('pause', this.update, options);
   this.button.addEventListener('click', () => {
    this.userPaused = !this.video.paused;
    if (this.userPaused) this.video.pause(); else this.video.play().catch(this.update);
   }, options);
   this.motion.addEventListener('change', () => { if (this.motion.matches) { this.userPaused = true; this.video.pause(); } }, options);
   this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.sync(); }, {threshold: .1});
   this.observer.observe(this);
   document.addEventListener('visibilitychange', () => this.sync(), options);
   this.update();
  }
  sync() { if (this.visible && !document.hidden && !this.userPaused) this.video.play().catch(this.update); else this.video.pause(); }
  disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); this.video?.pause(); }
 });
}

  } catch(e) { console.error(e); }
})();
})();
